"use client";

import { MindstringPrototype, type Target } from "@/generated/fastapi";
import StudioSituationArrangement from "../workflows/arrangement/StudioSituationArrangement";

type StudioSituationArrangementPanelProps = {
  prototype: MindstringPrototype;
  rerankTarget?: Target;
  situationId: string;
};

export default function StudioSituationArrangementPanel({
  prototype,
  rerankTarget,
  situationId,
}: StudioSituationArrangementPanelProps) {
  return (
    <StudioSituationArrangement
      prototype={prototype}
      situationId={situationId}
      rerankTarget={rerankTarget}
    />
  );
}
